module.exports = __webpack_public_path__ + "static/img/OG_Maco.f00e40e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/OG_Maco.jpg
// module id = BWUV
// module chunks = 1